import { Toast } from "@shopify/app-bridge/actions"

import stores from "@/stores"

import AppBridge, { isShopifyEmbedded } from "./app-bridge"

/**
 *
 * @param content
 * @param duration
 * @param error
 * @param id  在 request.ts 使用到了，request-error  如果指定了，那么只会弹出第一个
 */
const toast = (
  content: string,
  duration: number = 4e3,
  error: boolean = false,
  id?: string,
) => {
  if (isShopifyEmbedded() && !window.isFromAdmin) {
    Toast.create(AppBridge.app(), {
      duration,
      isError: error,
      message: content,
    }).dispatch(Toast.Action.SHOW)
    return
  }
  stores.CommonStore.addToast({ content, duration, error })
}

export default toast
